import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'Is it paper or digital?',
  a: 'It is a 100% digital product (High-Resolution PDF) optimized for iPad, Tablet, Laptop, and Smartphone. You receive instant access by email the moment your purchase is confirmed — no waiting, no shipping.'
}, {
  q: 'Do I need experience training dogs?',
  a: 'No. The system is designed for both new trainers in their first year of practice and experienced professionals who want a more structured, science-backed approach to behavior modification and session planning.'
}, {
  q: 'Does it work for group classes?',
  a: 'Yes. The sessions, programs, and templates are designed for both individual and group environments — including mixed-ability classes with dogs at different levels of training and reactivity.'
}, {
  q: "Can I use it with clients' dogs as well as my own?",
  a: 'Absolutely. The system was created specifically for real-world training environments — whether you work with your own dog at home, run private sessions, or manage a full client caseload as a professional trainer.'
}, {
  q: 'How quickly will I see results?',
  a: 'Most trainers report saving several hours of session preparation time during their very first week of use. In terms of dog behavior, clients consistently report measurable improvements within the first 2–3 weeks of implementing the protocols.'
}, {
  q: 'Does it work for reactive or aggressive dogs?',
  a: 'Yes. Reactive Dog Psychology™ and the Ready-To-Use Protocols are built specifically around fear-based reactivity, frustration, and leash aggression. For cases involving a serious bite history, we always recommend partnering with a Veterinary Behaviorist alongside the system.'
}, {
  q: 'Can I print the materials for use at the training field?',
  a: 'Yes. Every protocol, session template, and assessment form is printer-friendly. Many trainers print and laminate the Session Builder sheets to keep them handy during sessions.'
}, {
  q: 'Is this a one-time payment or a subscription?',
  a: 'It is a one-time payment of $27. You get lifetime access to the entire DOG TRAINER PRO™ system and all 5 premium bonuses, with no recurring fees and no hidden charges.'
}, {
  q: 'Do I get the 5 bonuses immediately?',
  a: 'Yes! All 5 premium bonuses are included with your purchase today and are delivered instantly by email alongside the main 6-in-1 system.'
}, {
  q: 'What is the refund process if I am not satisfied?',
  a: 'Simply email us within 7 days of your purchase and we will issue a full, no-questions-asked refund. No hoops to jump through and no fine print — your investment is 100% risk-free.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-7 px-4 sm:px-6 bg-brand-beige" data-id="element-36">
      <div className="text-center mb-5" data-id="element-37">
        <h2 className="text-2xl sm:text-3xl font-heading font-black text-brand-green mb-2 uppercase leading-tight" data-id="element-38">
          FREQUENTLY ASKED QUESTIONS
        </h2>
      </div>

      <div className="flex flex-col gap-2" data-id="element-39">
        {faqs.map((faq, i) => <div key={i} className="bg-white border border-brand-brown/15 rounded-md overflow-hidden shadow-sm" data-id="element-40">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-4 py-3.5 text-left flex justify-between items-center hover:bg-brand-green/5 transition-colors gap-3" aria-expanded={openIndex === i} data-id="element-41">
              <span className="font-bold text-brand-green text-sm leading-tight" data-id="element-42">
                {faq.q}
              </span>
              <ChevronDownIcon className={`w-4 h-4 text-brand-brown transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-43" />
            </button>

            {openIndex === i && <div className="px-4 pb-4 text-brand-ink/80 text-sm leading-snug border-t border-brand-brown/10 pt-3" data-id="element-44">
                {faq.a}
              </div>}
          </div>)}
      </div>
    </section>;
}